import PlanSimpleModifierService from "./plan-simple-modifier-service";

export default {
    teethIdsUpper: [17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27],
    teethIdsLower: [47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37],
    status: [],


    addStatus(status, jaw, tpl, steps) {
        this.status = app.$store.state.simplePlan.status;

        // Remove current status for jaw
        this.cleanupStatus(jaw);
        if (tpl=== null || parseInt(tpl.full_jaw) !== 1) status = this.getStatus(steps, jaw);

        this.status = this.status.concat(status);

        app.$store.state.simplePlan.status = this.status;
    },

    cleanupStatus(jaw) {
        this.status = this.status.filter((item) => {
            return ((jaw === "upper" && parseInt(item.tooth_id) > 30) || (jaw === "lower" && parseInt(item.tooth_id) < 30));
        });
    },

    getStatus(steps, jaw) {
        // Get main treatments
        const status = [];
        const statusMap = new Map();
        const mainSteps = {};
        /*app.$store.state.simplePlan.primaryTreatments.forEach((id) =>{
            mainSteps[String(id)] = [];
        });*/
        let fullJaw = false;
        const toothIds = jaw === "upper" ? this.teethIdsUpper : this.teethIdsLower;
        steps.forEach((step) => {
            //if (!Object.keys(mainSteps).includes(String(step.state_pid))) return;
            if (!step.primary) return;
            if (step.jaw !== jaw) return;
            fullJaw = step.fullJaw;
            // Fix 2020.10.17 - add crown -> crown on imp -> pillars will disappear
            if (typeof mainSteps[String(step.state_pid)] === "undefined") mainSteps[String(step.state_pid)] = [];
            mainSteps[String(step.state_pid)] = mainSteps[String(step.state_pid)].concat(step.tooth_id.split(","));
            // mainSteps[String(step.state_pid)] = step.tooth_id.split(",");
        });

        // Status for crowns should be worn except when implants found
        if (mainSteps["9"] && mainSteps["9"].length > 0) {
            mainSteps["9"].forEach((tId)=>{
                if ((mainSteps["10"] && mainSteps["10"].length > 0 && mainSteps["10"].includes(String(tId))) || (mainSteps["11"] && mainSteps["11"].length > 0 && mainSteps["11"].includes(String(tId)))) {
                    statusMap.set(parseInt(tId), 2);
                } else {
                    statusMap.set(parseInt(tId), 16);
                }
            });
        }

        // Bridges - break to parts
        if (mainSteps["15"] && mainSteps["15"].length > 0) {
            let bridges = [];
            bridges = Helper.breakBridgesToParts(mainSteps[15]);
            bridges.forEach((bridge) => {
                // Get bridge-implant intersect
                let intersect = [];
                if (mainSteps["10"] && mainSteps["10"].length > 0) intersect = Helper.getArrayIntersect(bridge, mainSteps["10"]);
                if (mainSteps["11"] && mainSteps["11"].length > 0) intersect = Helper.getArrayIntersect(bridge, mainSteps["11"]);
                // if (mainSteps["19"].length > 0) intersect = Helper.getArrayIntersect(bridge, mainSteps["19"]);
                // If bridge has implants underneath...
                if (intersect.length > 0) {
                    // ...set teeth to missing
                    bridge.forEach((tId)=>{
                        statusMap.set(parseInt(tId), 2);
                    });
                    // ..and add pillars for unpillared parts
                    if (!fullJaw && mainSteps["11"] && mainSteps["11"].length > 0) {
                        const implantIds = Helper.getTeethIdsBetween([parseInt(mainSteps["11"][0]), parseInt(mainSteps["11"][mainSteps["11"].length-1])]);
                        const parts = Helper.getUnpillaredBridgeParts(bridge, implantIds);
                        parts.forEach((part) => {
                            const pillars = PlanSimpleModifierService.getPillars(part);
                            pillars.forEach((pillarId)=>{
                               statusMap.set(parseInt(pillarId), 16);
                            });
                        });
                    }
                } else {
                    const pillars = PlanSimpleModifierService.getPillars(bridge);
                    bridge.forEach((tId) => {
                        if (pillars.includes(String(tId))) statusMap.set(parseInt(tId), 16);
                        else statusMap.set(parseInt(tId), 2);
                    });
                }
            });
        }

        if (mainSteps["10"]) {
            mainSteps["10"].forEach((tId) => {
                statusMap.set(parseInt(tId), 2);
            });
        }

        if (mainSteps["11"]) {
            mainSteps["11"].forEach((tId) => {
                statusMap.set(parseInt(tId), 2);
            });
        }

        if (mainSteps["26"]) {
            mainSteps["26"].forEach((tId) => {
                statusMap.set(parseInt(tId), 1);
            });
        }

        statusMap.forEach((stateId, toothId) => {
            status.push({
                tooth_id: toothId, state_id: stateId, state_pid: stateId,
            });
        });

        return status;
    },
};
